<script setup lang="ts">
import type { AdvancedDetectionFilters, DetectionFilters } from '@/types/filters/DetectionFilters'
import type { DetectionModel } from '@/types/models/DetectionModel'
import { NumberInputField, StackLayout } from '@rfc/rfc-components-library'
import DetectionsAdvancedFilters from '../DetectionsAdvancedFilters.vue'

type Props = {
    filters?: Partial<AdvancedDetectionFilters & DetectionFilters>
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<AdvancedDetectionFilters & DetectionModel>): void
}
defineEmits<Emits>()
</script>

<template>
    <DetectionsAdvancedFilters :filters="filters" @change="$emit('change', $event)">
        <StackLayout :gap="8" class="w-full" isResponsiveSmallScreen>
            <NumberInputField
                :label="$t('detection.filters.timerId')"
                :modelValue="filters?.timer_filter"
                :prefix="$t('unit.number')"
                @change="$emit('change', { timer_filter: $event })"
                class="w-full" />
            <NumberInputField
                :label="$t('detection.filters.eventId')"
                :modelValue="filters?.event_filter"
                @change="$emit('change', { event_filter: $event })"
                :prefix="$t('unit.number')"
                :disabled="!filters?.timer_filter"
                class="w-full" />
        </StackLayout>
    </DetectionsAdvancedFilters>
</template>

<style scoped lang="scss">
.advanced-datepicker {
    & :deep(.dropdown-menu) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-height: unset;

        @media screen and (max-width: 1023px) {
            margin-top: 7vh;
        }
    }
}
</style>
